import React, { useEffect, useRef, useState } from "react";
import Header from "../Sections/Business/Header/Header";
import Banner from "../Sections/Business/Banner/Banner";
import Zowo from "../Sections/Business/Choose/Zowo";
import Category from "../Sections/Business/Categories/Category";
import Industry from "../Sections/Business/Industries/Industry";
import FAQ from "../Sections/Business/FAQs/FAQ";
import Control from "../Sections/Business/Control/Control";
import FreeApp from "../Sections/Download/FreeApp";
import Footer from "../Footer/Footer";

const Business = () => {
  return (
    <>
      <Header></Header>
      <Banner></Banner>
      <Zowo></Zowo>
      <Category></Category>
      <Industry></Industry>
      <Control></Control>
      <FAQ></FAQ>
      <FreeApp></FreeApp>
      <Footer></Footer>
    </>
  );
};
export default Business;
